/**
 * @generated SignedSource<<956cf336172aa99009e728995a41b06b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Summary_UserProfile$data = {
  readonly profile: {
    readonly openToOpportunities: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"AvatarField_User" | "BadgesArea_User" | "IndustryField_User" | "LocationFields_User" | "NameFields_User" | "ProfileRateFields_User" | "SocialLinksFields_User" | "SpecializationsFields_User" | "TextIntroductionField_User">;
  readonly " $fragmentType": "Summary_UserProfile";
};
export type Summary_UserProfile$key = {
  readonly " $data"?: Summary_UserProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"Summary_UserProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Summary_UserProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "openToOpportunities",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SpecializationsFields_User"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TextIntroductionField_User"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LocationFields_User"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AvatarField_User"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NameFields_User"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IndustryField_User"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SocialLinksFields_User"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BadgesArea_User"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileRateFields_User"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "706473c234c6681bd3b2c398d10b0792";

export default node;
